import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Card, Form, Button, Container, Col } from "react-bootstrap";
import Guest from '../../../layouts/Guest';
import LogoURL from "../../../assets/img/baolinPrivate/logo-baolin-header-removebg-preview.png"

function LoginPage() {
  const [cardClasses, setCardClasses] = useState("card-hidden");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [saveEmail, setSaveEmail] = useState(false);
  const history = useHistory();

  React.useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    if (savedEmail) {
      setEmail(savedEmail);
      setSaveEmail(true);
    }
    setTimeout(() => {
      setCardClasses("");
    }, 700);
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/login`, { email, password });
      if (response.status === 200) {
        if (saveEmail) {
          localStorage.setItem("email", email);
        } else {
          localStorage.removeItem("email");
        }
        if (response.data.displayname) {
          localStorage.setItem("displayname", response.data.displayname);
        } else {
          localStorage.setItem("displayname", "Admin");
        }
        history.push("/admin/dashboard");
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <Guest>
      <div className="full-page section-image" data-color="black" data-image={require("assets/img/full-screen-image-2.jpg")}>
        <div className="content d-flex align-items-center p-0">
          <Container>
            <Col className="mx-auto" lg="4" md="8">
              <Form onSubmit={handleLogin} className="form">
                <Card className={"card-login " + cardClasses}>
                  <Card.Header className="text-center">
                    <img src={LogoURL} alt="Bao Lin Logo" width="130" />
                    <h3 className="header text-center">Admin Login</h3>
                  </Card.Header>
                  <Card.Body>
                    <Form.Group>
                      <label>Email address</label>
                      <Form.Control
                        placeholder="Enter email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group>
                      <label>Password</label>
                      <Form.Control
                        placeholder="Password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Check className="pl-0">
                      <Form.Check.Label>
                        <Form.Check.Input
                          type="checkbox"
                          checked={saveEmail}
                          onChange={(e) => setSaveEmail(e.target.checked)}
                        />
                        <span className="form-check-sign"></span>
                        Save my email address
                      </Form.Check.Label>
                    </Form.Check>
                  </Card.Body>
                  <Card.Footer className="ml-auto mr-auto">
                    <Button className="btn-wd" type="submit" variant="warning">
                      Login
                    </Button>
                  </Card.Footer>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
        <div
          className="full-page-background"
          style={{
            backgroundImage: "url(" + require("../../../assets/img/baolinPrivate/buddha.avif") + ")"
          }}
        ></div>
      </div>
    </Guest>
  );
}

export default LoginPage;
